import App from 'app/app.js';
import LtSelectionDrawerCtrl from 'app/directive/LtSelectionDrawerCtrl.js';

function LtEnlargeLookDrawerCtrl($scope, $timeout) {
  LtSelectionDrawerCtrl.call(this, $scope, $timeout);

  this.openWithLook = function (look) {
    this.look = look;
    this.open();
  };
}

App.controller('LtEnlargeLookDrawerCtrl', ['$scope', '$timeout', LtEnlargeLookDrawerCtrl]);
